import React                                from 'react';
import Link                                 from 'next/link';
import cx                                   from 'classnames';
import { connect }                          from 'react-redux';
import {activePath, setYmUserId, ymElem} from '../utils/helpers';
import WidgetProfile                        from './Widgets/WidgetProfile';
import WidgetLogin                          from './Widgets/WidgetLogin';
import WidgetLang                           from './Widgets/WidgetLang';
import User                                 from '../API/user';
// import Intercom, {IntercomAPI}              from 'react-intercom';
import Router                               from 'next/router';
import { trackEvent, trackTariff }                       from '../utils/tracking'

class Header extends React.PureComponent {
    getInitialProps({pathname, query}) {
        return {pathname}; // это станет начальным набором props у страницы
    }

    constructor(props) {
        super(props);

        this.state = {
            isFixed: false,
            dropProfile: 0,
			dropLang: 0,
            loginStatus: false,
            userInfo: props.userInfo,
            errors: null,
            type: 1,
            isAuthorized: !!(props.userInfo.account.id && props.userInfo.account.id > 0),
        };

        this.timer = null;
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);

        if(window) {
            // window.intercomSettings = {
            //     app_id: "p8jhuell"
            // };

            (function (window, callback) {
                (window[callback] = window[callback] || []).push(function() {
                    try {
                        window.yaCounter34362465 = new Ya.Metrika({
                            id:34362465,
                            clickmap:true,
                            trackLinks:true,
                            accurateTrackBounce:true,
                            webvisor:true,
                            trackHash:true
                        });
                    } catch(e) { }
                });
            })(window, "yandex_metrika_callbacks");

            this.initVisitorCheck();

            if (this.state.isAuthorized) {
                setYmUserId(this.props.userInfo.account.phone || this.props.userInfo.account.email);
                this.initJivoContactInfo();
            }
        }
    }

    async initVisitorCheck() {
        // if(this.state.isAuthorized)
        //     return;
        //
        // if(!await this.checkVisitor()) {
        //     window.setTimeout(() => this.initVisitorCheck(), 5000);
        // }
    }

    // async checkVisitor() {
    //     if(!window.Intercom)
    //         return false;
    //
    //     let visitorId = window.Intercom('getVisitorId');
    //     let visitorSent = false;
    //     if(visitorId) {
    //         console.log('visitor id', visitorId);
    //         await User.sendVisitor(visitorId).then(() => {
    //             console.info('visitor sent');
    //             visitorSent = true
    //         }).catch(() => {
    //             visitorSent = false
    //             console.error('visitor not sent');
    //         });
    //     } else {
    //         console.log('recheck intercom...')
    //     }
    //
    //     return visitorSent;
    // }

    initJivoContactInfo() {
        if (!this.setJivoContactInfo()) {
            setTimeout(() => this.initJivoContactInfo(), 5000);
        }
    }

    setJivoContactInfo() {
        if (!window.jivo_api)
            return false;

        if(this.state.isAuthorized) {
            let userInfo = this.state.userInfo;

            window.jivo_api.setContactInfo({
                name: [userInfo.account.name, userInfo.account.surname].filter(v => v != null && v != '').join(' '),
                email: userInfo.account.email,
                phone: userInfo.account.phone
            });

            if(userInfo.account.company_client) {
                let { id, name } = userInfo.account.company_client;
                window.jivo_api.setCustomData([{
                    title: 'Id компании',
                    content: "" + id
                },{
                    title: 'Наименование компании',
                    content: name
                }]);
            }
        }

        return true;
    }

    componentWillUnmount(){
        window.removeEventListener('scroll', this.handleScroll);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.userInfo !== newProps.userInfo) this.setState({
            userInfo: newProps.userInfo,
            isAuthorized: !!(newProps.userInfo.account.id && newProps.userInfo.account.id > 0)
        });
    }


    handleScroll = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if(window.pageYOffset >= 40 && !this.state.isFixed) this.setState({isFixed: true});
        if(window.pageYOffset <= 40 && this.state.isFixed) this.setState({isFixed: false});
    };

    /*menuOpen = (event) => {
        stopEvent(event);
        this.setState({dropProfile: 1});
        window.addEventListener('mouseleave', this.menuClose);
    };

    menuClose = (event) => {
        let canClose = !event.target.matches('.drop-wrapper.profile *');

        if(canClose) {
            this.setState({dropProfile: 0});
            window.removeEventListener('mouseleave', this.menuClose);
        }
    };*/

	menuOpen = () => {
		this.setState({
			dropProfile: 1,
			dropLang: 0
		});
	};

	menuClose = () => {
        this.setState({dropProfile: 0});
	};

	langOpen = () => {
		clearTimeout(this.timer);
		this.setState({
			dropLang: 1,
			dropProfile: 0
		});
	};

	langClose = () => {
		clearTimeout(this.timer);

		this.timer = setTimeout(() => {
			this.setState({dropLang: 0});
		}, 750)
	};

    resetPassword = async(phone) => {
        return await User.resetPassword(phone);
    };

    registration = async(phone) => {
        return await User.registration(phone);
    };

    setErroredPhone = () => {
        this.setState({errors: null, type: 1});
    };

    logout = () => {
        this.props.logout().then(() => Router.push('/'));
    };

    render() {
        const { lang, pathname, headerClass } = this.props;
        const { userInfo, type, isAuthorized } = this.state;

        let name = '', pic, headerBigCSS = {
            big: true,
            fixed: this.state.isFixed
        };

        if(headerClass) headerBigCSS[headerClass] = true;

        headerBigCSS = cx(headerBigCSS);

        const linkClients = cx({
            link: true,
            active: activePath(pathname) === 'clients'
        });

        const linkBusiness = cx({
            link: true,
            'b24-web-form-popup-btn-6': true,
            active: activePath(pathname) === 'business'
        });

        const linkDrivers = cx({
            link: true
        });

        const linkLK = cx({
            link: true,
            active: activePath(pathname) === 'lk'
        });

        const linkLang = cx({
            link: true,
            lang: true
        });

        const linkLogin = cx({
            link: true,
            login: true
        });

        const linkLoginActive = cx({
            'login-in': true
        });

        const linkApp = cx({
            link: true,
            active: pathname === '/app'
        });

        const linkCarPark = cx({
            link: true,
            active: pathname === '/carpark'
        });

        const linkTariff = cx({
            link: true,
            active: pathname === '/tariff'
        });

        const linkDashboard = cx({
            link: true,
            active: pathname === '/lk/orders'
        });

        const linkHelp = cx({
            link: true
        });

        const isPrivate = headerClass === 'private';

        if(isAuthorized) {
            name = userInfo.account.name ? userInfo.account.name : '';
            name += userInfo.account.surname ? ' ' + userInfo.account.surname : '';
            name = name ? name : userInfo.account.phone;

            pic = userInfo.account.picture_sizes ? userInfo.account.picture_sizes['320'] : '/static/img/avatar.head.svg';
        }



        // isActive={() => this.isActivePage(['/business'])}
        // isActive={() => this.isActivePage(['/', '/app', '/carpark', '/tariff', '/partners', '/job'])}

        let usr = {};
        if(isAuthorized) {
            usr = {
                name: [userInfo.account.name, userInfo.account.surname].filter(v => v != null && v != '').join(' '),
                user_id: userInfo.account.phone,
                email: userInfo.account.email
            };

            if(userInfo.account.company_client) {
                let { id, name } = userInfo.account.company_client;
                usr.company = { id, name }
            }
        }

        return (
            <header className="header">
                <div className="small">
                    <div className="container-fluid">
                        <div className="block_left" onClick={this.menuClose}>
                            <div className="link-wrapper">
                                <Link href='/'><a className={linkClients}>{lang.HeaderSmall_clients}</a></Link>
                                <Link href='/business'><a className={linkBusiness}>{lang.HeaderSmall_business}</a></Link>
                                <Link href='http://driver.mover24.ru/'><a target="_blank" className={linkDrivers}>{lang.HeaderSmall_drivers}</a></Link>
                                {/*isAuthorized ? (<Link href='/lk/orders'><a className={linkLK}>{lang.HeaderSmall_lk}</a></Link>) : null*/}
                            </div>
                        </div>
                        <div className="block_right">
							<div className="lang-wrapper">
								<div className="lang-inner" onMouseEnter={this.langOpen} onMouseLeave={this.langClose}>
									<div className="lang">
										<span className="title">{lang.appLang}</span>
										<i className="icon"/>
									</div>

									{this.state.dropLang === 1 ? <WidgetLang lang={lang}/> : null}
								</div>
							</div>

                            {userInfo.account.id ? (
                                <div className={linkLoginActive}>
                                    <div className="login-in-item">
                                        <div className="login-in-balance">
                                            <span className="title"><i className="icon" />{userInfo.sum ? userInfo.sum : '0'} <span className="als-rubl">₽</span></span>
                                        </div>
                                    </div>
                                    <div className="login-in-item" onClick={this.menuOpen}>
                                        <div className="login-in-user">
                                            <i className="icon"/>
                                            <span className="user">
												<img src={pic} alt=""/>
											</span>
                                            <span className="title">{name ? name : 'Пользователь'}</span>
                                        </div>
                                        { this.state.dropProfile === 1 ? <WidgetProfile
                                            userInfo={userInfo}
                                            lang={lang}
                                            logout={this.logout}
                                        /> : null }
                                    </div>
                                </div>
                            ) : (
                                <div onClick={this.menuOpen} className={linkLogin}>
                                    <span>{lang.HeaderSmall_login}</span>
                                    { this.state.dropProfile === 1 ? <WidgetLogin
                                        login={this.props.login}
                                        resetPassword={this.resetPassword}
                                        setErroredPhone={this.setErroredPhone}
                                        registration={this.registration}
                                        lang={lang}
                                        errors={userInfo.errors}
                                        type={type}
                                    /> : null }
                                </div>
                            )}
                        </div>
                    </div>
                </div>

				{isPrivate ? null : (
					<div className={headerBigCSS} onClick={this.menuClose}>
						<div className="container-fluid">
							<div className="burger"/>
							<div className="block_left">
								<Link href="/">
									<a className="logo">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 119.469 28" className="icon-page" width="119" height="28">
											<g transform="translate(-3379 7300)">
												<path className="cls-1" d="M473.581,694.035l8.442-8.451h-2.413l-6.029,6.087-6.033-6.087h-2.41l8.439,8.451v0h0Zm-27.179-8.41-6.816,6.222h0l-6.823-6.228-1.708,0v8.257h1.767v-5.946l1.115.968,5.647,5.159v.006l5.644-5.159,1.116-.968v5.945h1.764v-8.258Zm19.507,4.691c.008-.075.012-.154.016-.236,0-.014,0-.023,0-.034v0c0-.1,0-.2,0-.311,0-.2-.007-.4-.021-.573v-.015h0a3.36,3.36,0,0,0-.063-.459.057.057,0,0,0,0-.02.927.927,0,0,0-.042-.152,3.368,3.368,0,0,0-2.036-2.243,20.068,20.068,0,0,0-11.922,0,3.385,3.385,0,0,0-2.027,2.194,4.094,4.094,0,0,0-.145,1.258c0,.161.007.308.015.45h0v.006h0a4.177,4.177,0,0,0,.043.433.931.931,0,0,0,.016.093,1.6,1.6,0,0,0,.054.225,3.372,3.372,0,0,0,2.057,2.243,15.468,15.468,0,0,0,6.013.889c4.848,0,7.462-1.053,7.963-3.208a1.443,1.443,0,0,0,.036-.176,3.474,3.474,0,0,0,.04-.362Zm-1.745-.443h0v.013c0,1.692-2.065,2.513-6.311,2.513a14.833,14.833,0,0,1-4.7-.557c-1.093-.392-1.663-1.025-1.7-1.876h0v-.625h.008c.06-.816.619-1.428,1.68-1.82a19.542,19.542,0,0,1,9.328,0,2.249,2.249,0,0,1,1.65,1.61c0,.027.008.052.011.076.006.039.017.076.019.117h0l0,.035a.01.01,0,0,0,0,.007v0l.01.164v.34Zm45.538,1.233a2.575,2.575,0,0,0,1.68-.814,2.928,2.928,0,0,0,.7-1.93c0-.1-.006-.206-.016-.311a.13.13,0,0,0,0-.019,2.8,2.8,0,0,0-.047-.291h0a2.518,2.518,0,0,0-2.3-2.127h0l-11.586,0H497.8v8.257h1.77v0h0v-2.753h7.653l2.9,2.743h2.524l-2.951-2.755Zm-.365-1.6v0a1.568,1.568,0,0,1-.293.01h-9.468v-2.3h9.753a.915.915,0,0,1,.35.086.391.391,0,0,1,.047.022.87.87,0,0,1,.137.085c.006.005.013.009.019.014a.836.836,0,0,1,.134.13c.012.012.02.025.029.035a.9.9,0,0,1,.085.121.235.235,0,0,1,.032.054,1.193,1.193,0,0,1,.057.124l.024.062a.994.994,0,0,1,.038.143c0,.018.009.038.014.056a1.219,1.219,0,0,1,0,.424c0,.021-.009.039-.014.058a.93.93,0,0,1-.038.14c-.008.022-.016.043-.024.063-.017.041-.036.083-.057.124a.316.316,0,0,1-.032.054,1.045,1.045,0,0,1-.085.121.23.23,0,0,1-.029.034.844.844,0,0,1-.134.13c-.006.006-.013.01-.019.015a.953.953,0,0,1-.137.084.18.18,0,0,1-.047.023.935.935,0,0,1-.343.087Zm-24.94-.574v-1.752h11.772V685.6H482.643v8.283h13.526v-1.6H484.4V690.51h10.677v-1.577H484.4Z" transform="translate(2985.815 -7975.725)"/>
												<path className="cls-2" d="M320.36,666.956l-3.239-11.651h0a2.113,2.113,0,0,0-4.027-.056h0l-.009.024c0,.012-.007.025-.01.035l-3.18,10.743a.7.7,0,0,1-1.33-.01v0l-4.973-14.065a3.572,3.572,0,0,0-6.874.041c-.031.089-.062.186-.09.295-.007.022-.157.513-.165.536-.617,2.283-1.255,4.557-1.89,6.835q-.98,3.528-1.967,7.053c-.166.6-.327,1.195-.489,1.792l-.067.246a4.726,4.726,0,1,0,6.8,1.584q.77-3.788,1.535-7.573c.14-.684.28-1.363.429-2.043a.7.7,0,0,1,1.281-.106q.727,1.705,1.443,3.414c.753,1.8,2.383,5.361,3.239,7.344l.007.007a2.521,2.521,0,0,0,4.767-.077h0l0-.008c.006-.017.009-.034.014-.049.217-.738.429-1.474.648-2.214l2.4-8.092a.7.7,0,0,1,1.317,0l1.883,6.715a2.311,2.311,0,1,0,2.549-.717Zm-25.638,8.07a2.365,2.365,0,1,1,1.677-.69A2.365,2.365,0,0,1,294.723,675.027ZM319.6,670.2a1.072,1.072,0,1,1,1.073-1.072A1.072,1.072,0,0,1,319.6,670.2Z" transform="translate(3089.009 -7949.399)"/>
											</g>
										</svg>
									</a>
								</Link>
							</div>
							<div className="block_right links">
								<Link href='/app'><a className={linkApp}>{lang.headerBig_APPs}</a></Link>
								<Link href="/carpark"><a className={linkCarPark}>{lang.headerBig_CarPark}</a></Link>
								<Link href='/tariff'><a className={linkTariff}>{lang.headerBig_Tariff}</a></Link>
								<Link href='http://help.mover24.ru/'><a target='_blank' className={linkHelp}>{lang.headerBig_Help}</a></Link>

								<button id="calculatorBtnHead" className="btn-take-order" onClick={() => trackEvent('calculate_price_header', this.props.openCalc)}>{lang.headerBig_btn_calc}</button>
							</div>
						</div>
					</div>
				)}
                {/*<Intercom appID="p8jhuell" { ...usr } />*/}
            </header>
        )
    }
}

const mapState = state => ({
    lang: state.lang,
    userInfo: state.user,
});

const mapDispatch = ({ user: { getUserInfo, getUserCards, getUserBalance, getUserPromoCode, getUserInfoFull, logout, login }}) => ({
    getUserInfo:        () => getUserInfo(),
    getUserCards:       () => getUserCards(),
    getUserBalance:     () => getUserBalance(),
    getUserPromoCode:   () => getUserPromoCode(),
    getUserInfoFull:    () => getUserInfoFull(),
    logout:             () => logout(),
    login:              (username, password) => login({username, password})
});

export default connect(mapState, mapDispatch, null, { pure: false, withRef: true })(Header);
